module.exports = __webpack_public_path__ + "_assets/img/Frame1207.53a59b1a.svg";